import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, finalIncludes, trackCheckout } from '../data/offer';
const noMore = ['No more hours searching for drills', 'No more repeating the same sessions because you ran out of ideas', 'No more random combinations without purpose', 'No more wondering what should come next', 'No more conditioning that replaces technical coaching', 'No more visible improvisation when a session stops working', 'No more depending on the same handful of exercises', 'No more giving away your free time to planning'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-cream border-t border-silver-light relative overflow-hidden" data-id="element-94" data-mp="vwuk78qpl2le">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-95" data-mp="qxrq2jc9ogs7">
        <div className="text-center mb-16" data-id="element-96" data-mp="14whn5yz36ggk">
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-97" data-mp="14tddim2uqsii">
            Your next coaching week
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-8 leading-tight text-ink" data-id="element-98" data-mp="2c56i0n7mb3sd">
            Next week you can keep building every boxing session from scratch...
            <br data-id="element-99" data-mp="2m340sv6pk8dl" />
            <span className="text-accent" data-id="element-100" data-mp="2m2kt07arv0da">
              Or you can walk into the gym with the structure already ready.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-paper p-8 rounded-2xl border border-silver-light" data-id="element-101" data-mp="2qzuj7p5zjg26">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-102" data-mp="301arnrd8p83r">
                <span className="text-accent mt-0.5" aria-hidden="true" data-id="element-103" data-mp="34sshbj9tbm9f">
                  ✦
                </span>
                <span className="text-graphite" data-id="element-104" data-mp="39sootshpxvtq">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-ink mb-2" data-id="element-105" data-mp="3esjfpw1hules">
            Boxing Coach Ready does not replace your coaching.
          </p>
          <p className="text-2xl font-display font-bold text-accent mb-6" data-id="element-106" data-mp="3itcyyc3zrc1c">
            You are still the coach.
          </p>
          <p className="text-xl text-graphite mb-16" data-id="element-107" data-mp="1ep8qdrqifa8b">
            What it gives you is the structure and material to make your knowledge easier to
            organize, easier to deliver and easier to progress.
          </p>
        </div>
        <div className="bg-paper border-2 border-ink rounded-3xl p-8 md:p-12 shadow-[0_20px_50px_-38px_rgba(21,23,26,0.45)]" data-id="element-108" data-mp="1novsyguz6m2y">
          <h3 className="text-2xl font-display font-bold text-ink mb-6 text-center border-b border-silver-light pb-6" data-id="element-109" data-mp="22d9w6swb0ck1">
            Everything included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-110" data-mp="2bfsv51wyy510">
            {finalIncludes.map(item => <div key={item} className="flex items-start gap-3" data-id="element-111" data-mp="27f8ydzgb53fe">
                <Check size={18} className="text-accent shrink-0 mt-0.5" aria-hidden="true" data-id="element-112" data-mp="h0yln4zca8di" />
                <span className="text-sm text-graphite" data-id="element-113" data-mp="d06cscudq5hr">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-114" data-mp="2vpyvp0gmygl">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-silver-light text-graphite text-lg" data-id="element-115" data-mp="2wrjak3d8xaz">
              The best time to have a complete boxing coaching system was before the first session
              you ever had to build from scratch.
              <br data-id="element-116" data-mp="3u9u9hod807w3" />
              <span className="text-accent-dark font-display font-bold" data-id="element-117" data-mp="3u9cfkye165rc">
                The second best time is today.
              </span>
            </div>
            <p className="text-xl font-display font-extrabold text-ink mb-2" data-id="element-118" data-mp="3kc7uz2zu2icn">Boxing Coach Ready</p>
            <p className="text-sm text-graphite-light mb-2" data-id="element-119" data-mp="36cye013szk7m">
              7 complete volumes · 150 ready-to-coach sessions · 5 bonus guides
            </p>
            <p className="text-sm text-graphite-light mb-8" data-id="element-120" data-mp="3bc1klpzflyhp">
              Built for boxing coaches who want to plan less, coach with structure and develop
              better boxers.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-xl py-5 md:py-6 px-8 md:px-12 mb-6" data-id="element-121" data-mp="19jn32s0suw1t">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-graphite-light" data-id="element-122" data-mp="2vo28q3sw77qb">
              <span data-id="element-123" data-mp="2rn07xijbunm8">7-Day Guarantee</span>
              <span data-id="element-124" data-mp="2rq4iqyrashlv">Secure Payment</span>
              <span data-id="element-125" data-mp="2moytxc0rdehm">Instant Access</span>
              <span data-id="element-126" data-mp="2mqrzenzmxso1">Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}